export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.4fd28a6c.woff";